import React from 'react';
import '../css/Div4.css';

const Div4 = () => {
  return (
    <div id="div4" className="div4">
    <h1>Om hemsidan</h1>
    <p>Denna hemsida är byggd från grunden av mig Jens Holm. Med hjälp av javascript-ramverket React, och drivs av githubs servrar. Syftet är att förmedla mina kunskaper och skapa en digital närvaro som gynnar min karriär.</p>
    </div>
  );
};

export default Div4;
